import React, { useEffect } from "react";
import "./SelectProducts.scss";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import Cover from "../Cover/Cover";
import Product from "../Product/Product";
import {
    filterFloorplans,
    updateProductFilterValue,
} from "../../redux/actions/floorplanActions";

function SelectProducts() {
    var dispatch = useDispatch();
    var content = useSelector((state) => state.content.pages.floorplans);
    var products = useSelector((state) => state.floorplan.products);
    var history = useHistory();
    const isTouchScreen = useSelector((state) => state.utilities.isTouchScreen);
    var floorplans = useSelector((state) => state.floorplan.floorplans);
    var multiFlex = useSelector((state) => state.content.pages.poppy);

    function clickNavigate(key, value) {
        //we need to update teh filter value and also filter the floorplans before we move to that page
        dispatch(updateProductFilterValue(key, value));
        dispatch(filterFloorplans());
        history.push("/floorplans/list");
    }

    function multiFlexClick() {
        history.push("/multi-flex/poppy");
    }

    function productHasActiveLots(product) {
        for (var i = 0; i < floorplans.length; i++) {
            if (floorplans[i].type[0].name == product.name) return "";
        }

        return " hide";
    }

    function productClassFromSize(size) {
        var text = " blue";

        switch (size) {
            case "30":
                text = " blue";
                break;
            case "36":
                text = " green";
                break;
            case "40":
                text = " orange";
                break;
        }

        return text;
    }

    if (typeof content !== "undefined") {
        //setup the new product
        var displayProducts = [];
        var index = -1;

        if (products.length > 0 && false) {
            var injectProduct = {
                term_id: -1,
            };

            //now loop and add to it
            for (var i = 0; i < products.length; i++) {
                if (products[i].term_id == 11) {
                    //this is the oen we want
                    index = i + 1;
                }
            }

            if (index != -1) {
                displayProducts = products
                    .slice(0, index)
                    .concat([injectProduct])
                    .concat(products.slice(index));
            } else displayProducts = products;
        } else displayProducts = products;
        return (
            <div
                className={`SelectProducts${isTouchScreen ? " touchscreen" : ""}`}
            >
                <Cover fadeImmediately />
                <h1 className="heading">
                    {content.floorplan_product_type_heading}
                </h1>
                <div className="product-card-container">
                    {displayProducts.map((product, key) => {
                        if (product.term_id == -1) {
                            return (
                                <button
                                    className="product-card green"
                                    onClick={() => multiFlexClick()}
                                >
                                    <div className="product-image-wrapper">
                                        <img
                                            className="product-image"
                                            src={multiFlex.landing_large_image}
                                        />
                                    </div>
                                    <h2 className="product-heading">
                                        {multiFlex.details_heading}
                                    </h2>
                                    <div className="product-display-container">
                                        <div className="stats-container">
                                            <div className="stat">
                                                <img
                                                    src={
                                                        multiFlex.details_sqft_icon
                                                    }
                                                    className="icon"
                                                />
                                                <span className="content">
                                                    {multiFlex.details_sqft}
                                                </span>
                                            </div>
                                            <div className="stat">
                                                <img
                                                    src={
                                                        multiFlex.details_bedroom_icon
                                                    }
                                                    className="icon"
                                                />
                                                <span className="content">
                                                    {multiFlex.details_bedrooms}
                                                </span>
                                            </div>
                                            <div className="stat">
                                                <img
                                                    src={
                                                        multiFlex.details_bathroom_icon
                                                    }
                                                    className="icon"
                                                />
                                                <span className="content">
                                                    {
                                                        multiFlex.details_bathrooms
                                                    }
                                                </span>
                                            </div>
                                        </div>
                                        <img
                                            src={multiFlex.landing_icon}
                                            className="display-icon"
                                        />
                                    </div>
                                </button>
                            );
                        } else {
                            if (index != -1) {
                                if (key > index) {
                                    key = key - 1;
                                }
                            }
                            return (
                                <button
                                    className={`product-card${productHasActiveLots(product)} ${productClassFromSize(product.slug)}`}
                                    onClick={() =>
                                        clickNavigate(key, product.term_id)
                                    }
                                >
                                    <div className="product-image-wrapper">
                                        <img
                                            className="product-image"
                                            src={
                                                content
                                                    .floorplan_product_type_data[
                                                    key
                                                ].product_image.url
                                            }
                                        />
                                    </div>
                                    <h2 className="product-heading">
                                        {product.name}
                                        {
                                            content.floorplan_product_type_data[
                                                key
                                            ].product_after_type_text
                                        }
                                    </h2>
                                    {false && (
                                        <p className="product-copy">
                                            {
                                                content
                                                    .floorplan_product_type_data[
                                                    key
                                                ].product_description
                                            }
                                        </p>
                                    )}
                                    <div className="product-display-container">
                                        <div className="stats-container">
                                            {content.floorplan_product_type_data[
                                                key
                                            ].product_stats.map(
                                                (stat, sKey) => {
                                                    //console.log(stat);

                                                    return (
                                                        <div className="stat">
                                                            <img
                                                                src={stat.icon}
                                                                className="icon"
                                                            />
                                                            <span className="content">
                                                                {stat.content}
                                                            </span>
                                                        </div>
                                                    );
                                                }
                                            )}
                                        </div>
                                        <img
                                            src={
                                                content
                                                    .floorplan_product_type_data[
                                                    key
                                                ].product_icon.url
                                            }
                                            className="display-icon"
                                        />
                                    </div>
                                </button>
                            );
                        }
                    })}
                    {typeof multiFlex !== "undefined" && false && (
                        <button
                            className="product-card green"
                            onClick={() => multiFlexClick()}
                        >
                            <div className="product-image-wrapper">
                                <img
                                    className="product-image"
                                    src={multiFlex.landing_large_image}
                                />
                            </div>
                            <h2 className="product-heading">
                                {multiFlex.details_heading}
                            </h2>
                            <div className="product-display-container">
                                <div className="stats-container">
                                    <div className="stat">
                                        <img
                                            src={multiFlex.details_sqft_icon}
                                            className="icon"
                                        />
                                        <span className="content">
                                            {multiFlex.details_sqft}
                                        </span>
                                    </div>
                                    <div className="stat">
                                        <img
                                            src={multiFlex.details_bedroom_icon}
                                            className="icon"
                                        />
                                        <span className="content">
                                            {multiFlex.details_bedrooms}
                                        </span>
                                    </div>
                                    <div className="stat">
                                        <img
                                            src={
                                                multiFlex.details_bathroom_icon
                                            }
                                            className="icon"
                                        />
                                        <span className="content">
                                            {multiFlex.details_bathrooms}
                                        </span>
                                    </div>
                                </div>
                                <img
                                    src={multiFlex.landing_icon}
                                    className="display-icon"
                                />
                            </div>
                        </button>
                    )}
                </div>
            </div>
        );
    } else {
        return <div></div>;
    }
}

export default SelectProducts;
